import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const TableWrapper = styled.div`
  margin-bottom: 120px;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const Separator = styled.div`
  width: 100%;
  display: flex;
`;

export const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ScrollableContainer = styled.div`
  flex: 1;
  max-height: calc(100vh - 262px);
  overflow-y: auto;
  scroll-behavior: smooth;
  max-width: 764px;
  width: 100%;
  ${customScrollMinimal};
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

export const Section = styled.div`
  box-sizing: border-box;
`;

export const UpcomingCatalysts = styled.span`
  ${typographyV2.titleBase};
  color: var(--text-soft);
`;

export const HistoricalReactionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
